import React from "react";
import AIAMultiBenefitDiscountModal from "./AIA/AIAMultiBenefitDiscountModal";
import AsteronMultiBenefitDiscountModal from "./Asteron/AsteronMultiBenefitDiscountModal";
import ChubbLifeMultiBenefitDiscountModal from "./ChubbLife/ChubbLifeMultiBenefitDiscountModal";
import PartnersLifeMultiBenefitDiscountModal from "./PatnersLife/PartnersLifeMultiBenefitDiscountModal";

interface IMultiBenefitDiscountModalProps {
    providerId: number;
    isOpen: boolean;
    onClose: () => void;
}

const MultiBenefitDiscountModal: React.FC<IMultiBenefitDiscountModalProps> = (props) => {
    const { providerId, isOpen, onClose } = props;

    switch (providerId) {
        // AIA
        case 2:
            return <AIAMultiBenefitDiscountModal isOpen={isOpen} onClose={onClose} />;
        // Asteron
        case 4:
            return <AsteronMultiBenefitDiscountModal isOpen={isOpen} onClose={onClose} />;
        // Chubb Life
        case 9:
            return (
                <ChubbLifeMultiBenefitDiscountModal isOpen={isOpen} onClose={onClose} />
            );

        // PL
        case 6:
            return (
                <PartnersLifeMultiBenefitDiscountModal
                    isOpen={isOpen}
                    onClose={onClose}
                />
            );

        default:
            return null;
    }
};

export default MultiBenefitDiscountModal;
